<template>
  <div
    class="ebook-header"
    :class="{
      'ebook-header--has-cover': hasImageCover,
      'ebook-header--video': isVideoCover
    }"
    :style="headerStyle"
  >
    <div class="ebook-header__content content-container">
      <div class="container-fluid">
        <img
          v-if="!hasCover"
          class="ebook-header__logo"
          :src="$setup.partnerLogo"
          :alt="headerConfig.name"
        />
        <h1 class="page-title ebook-header__title">
          {{ headerConfig.name }}
        </h1>
        <p v-if="headerDescription" class="ebook-header__description">
          {{ headerDescription }}
        </p>
      </div>
    </div>
    <video-background
      v-if="isVideoCover && videoURL"
      :url="videoURL"
      class="d-none d-md-block"
    />
    <div v-if="hasCover" class="ebook-header__overlay"></div>
  </div>
</template>

<script>
import isMobile from "ismobilejs";
import VideoBackground from "@/components/preview/VideoBackground";
import activeContentHeader from "@/mixins/activeContentHeader";

export default {
  name: "EbookHeader",
  mixins: [activeContentHeader],
  components: {
    VideoBackground
  },
  computed: {
    isMobileDevice() {
      return isMobile().any;
    },
    coverType() {
      if (this.isMobileDevice) {
        return (
          this.headerConfig.cover_view_type_mobile ||
          this.headerConfig.cover_view_type
        );
      }
      return this.headerConfig.cover_view_type;
    },
    videoURL() {
      if (this.isMobileDevice && this.headerConfig.link_video_mobile) {
        return this.headerConfig.link_video_mobile;
      }
      return this.headerConfig.link_video;
    },
    isVideoCover() {
      return (
        ["video", "image_and_video"].includes(this.coverType) && !!this.videoURL
      );
    },
    bannerUrl() {
      if (this.isMobileDevice && this.headerConfig.cover_mobile) {
        return this.headerConfig.cover_mobile;
      }
      return this.headerConfig.cover || null;
    },
    hasImageCover() {
      return !!this.bannerUrl;
    },
    hasCover() {
      return this.hasImageCover || this.isVideoCover;
    },
    headerStyle() {
      if (this.hasImageCover) {
        return `background-image: url("${this.bannerUrl}");`;
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.ebook-header {
  position: relative;
  background-size: cover;
  background-position: center;
  background-color: #151823;
  color: white;
  min-height: 280px;

  &--has-cover {
    padding-top: 28.875%;
    min-height: unset;

    @media screen and (max-width: 991px) {
      padding-top: 89%;
    }

    @media screen and (max-width: 576px) {
      padding-top: 132%;
    }
  }

  &--video {
    @media screen and (min-width: 768px) {
      padding-top: 0 !important;
      min-height: unset;
    }
  }

  &__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 32px;
  }

  &__logo {
    max-height: 48px;
    max-width: 160px;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 8px;

    @media screen and (max-width: 768px) {
      font-size: 24px;
    }
  }

  &__description {
    font-size: 16px;
    line-height: 1.6;
    margin: 0;
    max-width: 600px;
    opacity: 0.85;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    pointer-events: none;
    background: linear-gradient(
        -270deg,
        rgba(11, 11, 18, 0) 40%,
        rgba(11, 11, 18, 0.5) 70%,
        rgba(11, 11, 18, 0.85) 100%
      ),
      linear-gradient(
        0deg,
        rgba(11, 11, 18, 0.9) 0%,
        rgba(11, 11, 18, 0.4) 20%,
        rgba(11, 11, 18, 0) 50%
      );
  }
}
</style>
